import(/* webpackMode: "eager" */ "/vercel/path1/app/(landing)/page.tsx");
